import { render } from "./dataStat.vue?vue&type=template&id=451f17cf&scoped=true"
import script from "./dataStat.vue?vue&type=script&lang=js"
export * from "./dataStat.vue?vue&type=script&lang=js"

import "./dataStat.vue?vue&type=style&index=0&id=451f17cf&scoped=true&lang=less"
import "./dataStat.vue?vue&type=style&index=1&id=451f17cf&lang=css"

import exportComponent from "D:\\web\\dmsm\\dmsm-pages\\cloud\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-451f17cf"]])

export default __exports__